import { PropsWithChildren } from 'react';
import { Box, Stack, StackProps } from '@mui/material';
import { COLOR_BG_SECONDARY } from 'shared';

import { warningSvg } from './images';

export const WarningBox = ({ children, ...props }: PropsWithChildren & StackProps) => {
  return (
    <Stack
      bgcolor={COLOR_BG_SECONDARY}
      direction="row"
      alignItems="start"
      borderRadius={3}
      gap={1.5}
      p={1.5}
      mb={{ xs: 1, sm: 3 }}
      {...props}
    >
      <Box component="img" alt="warning" src={warningSvg} width={20} height={24} />
      {children}
    </Stack>
  );
};
